export default "__VITE_ASSET__C0hlE9ah__ 584w";